/**
 * Spaltenüberschrift von Verkettungsaufgaben.
 * 
 * @class directive_v3sDecisions
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').directive('v3sDecisions', function () {
    return {
        restrict: 'E',
        require: '^v3sExercise',
        link: function (scope, element, attrs, controllers) {
            var exCtrl = controllers;
            var decisions = element.find("v3s-decision");
            var decisionsObj = [];
            var $d;
            angular.forEach(decisions, function (d) {
                $d = angular.element(d);
                $d.addClass('cc-decision');
                $d.css('width', attrs.v3sSpacing + 'px');
                decisionsObj.push({
                    'element': $d,
                    'id': $d.attr('v3s-index')
                });
            });
            exCtrl.setDecisionSettings({
                left: element.css('left'),
                spacing: attrs.v3sSpacing,
                decisions: decisionsObj
            });
        }
    };
});
